import React, { Component } from "react";
import { components } from "react-select";
import MySelect from "./MySelect";
import makeAnimated from "react-select/animated";

export default class CustomMultiSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      optionSelected: null,
    };
  }

  handleChange = (selected) => {
    this.setState({
      optionSelected: selected,
    });
  };

  render() {
    return (
      <MySelect
        options={this.props.options}
        isMulti
        defaultValue={this.props.defaultValue || null}
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        components={{ Option, MultiValue, animatedComponents }}
        onChange={this.props.handleChange}
        allowSelectAll={true}
        value={this.props.value}
      />
    );
  }
}

const Option = (props) => {
  return (
    <div>
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
        />{" "}
        <label>{props.label}</label>
      </components.Option>
    </div>
  );
};

const MultiValue = (props) => (
  <components.MultiValue {...props}>
    <span>{props.data.label}</span>
  </components.MultiValue>
);

const animatedComponents = makeAnimated();
